import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { aorsApi } from "@/lib/api";
import type { AorCreate, AorUpdate } from "@/types";

export function useAors() {
  return useQuery({
    queryKey: ["aors"],
    queryFn: () => aorsApi.list(),
  });
}

export function useAor(id: string) {
  return useQuery({
    queryKey: ["aors", id],
    queryFn: () => aorsApi.get(id),
    enabled: !!id,
  });
}

export function useCreateAor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: AorCreate) => aorsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["aors"] }),
  });
}

export function useUpdateAor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: AorUpdate }) =>
      aorsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["aors"] }),
  });
}

export function useDeleteAor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => aorsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["aors"] }),
  });
}
